import React from "react";
import Cookies from "js-cookie";

// Rupee prices have a 40 rupee shipping fee folded in by convertPrice; dollar
// prices have nothing added, so US orders ship free. This renders that as an
// offer wherever a price is shown, and renders nothing at all for INR -- there
// is no free shipping to advertise on Indian orders.
//
// `variant` only controls presentation:
//   "inline" - a quiet line under a price
//   "badge"  - a filled pill, for cart and checkout summaries
//   "banner" - the full width strip above the navbar, rendered once in App.js
const OFFER_HEADLINE = "Shipping on us";
const OFFER_DETAIL = "Introductory offer — free delivery on every US order";

const ShippingOffer = ({ variant = "inline", className = "" }) => {
  const selectedCountry = Cookies.get("country");
  if (selectedCountry === "INR") return null;

  if (variant === "banner") {
    return (
      <div
        role="status"
        className={`w-100 text-center py-2 px-3 ${className}`}
        style={{
          background: "linear-gradient(90deg, #0f5132, #198754)",
          color: "#ffffff",
          fontSize: "0.9rem",
          letterSpacing: "0.02em",
        }}
      >
        <i className="bi bi-truck me-2" aria-hidden="true"></i>
        <strong>{OFFER_HEADLINE}</strong>
        <span className="d-none d-sm-inline">
          <span className="mx-2" aria-hidden="true">
            &middot;
          </span>
          {OFFER_DETAIL}
        </span>
      </div>
    );
  }

  if (variant === "badge") {
    return (
      <span
        className={`badge rounded-pill bg-success-subtle text-success-emphasis border border-success-subtle ${className}`}
      >
        <i className="bi bi-truck me-1" aria-hidden="true"></i>
        {OFFER_HEADLINE} &mdash; introductory offer
      </span>
    );
  }

  return (
    <small className={`d-block text-success fst-italic ${className}`}>
      <i className="bi bi-truck me-1" aria-hidden="true"></i>
      {OFFER_HEADLINE} &mdash; introductory offer
    </small>
  );
};

export default ShippingOffer;
